export * from './auditLogs.service';
import { AuditLogsService } from './auditLogs.service';
export * from './barcodes.service';
import { BarcodesService } from './barcodes.service';
export * from './containers.service';
import { ContainersService } from './containers.service';
export * from './cookingDepartments.service';
import { CookingDepartmentsService } from './cookingDepartments.service';
export * from './countries.service';
import { CountriesService } from './countries.service';
export * from './defaultSettings.service';
import { DefaultSettingsService } from './defaultSettings.service';
export * from './dietaryInformation.service';
import { DietaryInformationService } from './dietaryInformation.service';
export * from './expenseGroups.service';
import { ExpenseGroupsService } from './expenseGroups.service';
export * from './factorNotes.service';
import { FactorNotesService } from './factorNotes.service';
export * from './factors.service';
import { FactorsService } from './factors.service';
export * from './futurePrices.service';
import { FuturePricesService } from './futurePrices.service';
export * from './integration.service';
import { IntegrationService } from './integration.service';
export * from './locationSegments.service';
import { LocationSegmentsService } from './locationSegments.service';
export * from './locationTypes.service';
import { LocationTypesService } from './locationTypes.service';
export * from './mixAndMatchLocations.service';
import { MixAndMatchLocationsService } from './mixAndMatchLocations.service';
export * from './mixAndMatchPromotions.service';
import { MixAndMatchPromotionsService } from './mixAndMatchPromotions.service';
export * from './mixAndMatchPurchaseRequirementSetProductGroups.service';
import { MixAndMatchPurchaseRequirementSetProductGroupsService } from './mixAndMatchPurchaseRequirementSetProductGroups.service';
export * from './mixAndMatchPurchaseRequirementSetProducts.service';
import { MixAndMatchPurchaseRequirementSetProductsService } from './mixAndMatchPurchaseRequirementSetProducts.service';
export * from './mixAndMatchPurchaseRequirements.service';
import { MixAndMatchPurchaseRequirementsService } from './mixAndMatchPurchaseRequirements.service';
export * from './offerLocationTypes.service';
import { OfferLocationTypesService } from './offerLocationTypes.service';
export * from './offerLocations.service';
import { OfferLocationsService } from './offerLocations.service';
export * from './offerRuleProductGroups.service';
import { OfferRuleProductGroupsService } from './offerRuleProductGroups.service';
export * from './offerRuleProductRanges.service';
import { OfferRuleProductRangesService } from './offerRuleProductRanges.service';
export * from './offerRuleProducts.service';
import { OfferRuleProductsService } from './offerRuleProducts.service';
export * from './offerRules.service';
import { OfferRulesService } from './offerRules.service';
export * from './offerVenues.service';
import { OfferVenuesService } from './offerVenues.service';
export * from './offers.service';
import { OffersService } from './offers.service';
export * from './organisationSettings.service';
import { OrganisationSettingsService } from './organisationSettings.service';
export * from './organisations.service';
import { OrganisationsService } from './organisations.service';
export * from './packageItemSubstituteProductGroups.service';
import { PackageItemSubstituteProductGroupsService } from './packageItemSubstituteProductGroups.service';
export * from './packageItemSubstitutes.service';
import { PackageItemSubstitutesService } from './packageItemSubstitutes.service';
export * from './packageItems.service';
import { PackageItemsService } from './packageItems.service';
export * from './priceChanges.service';
import { PriceChangesService } from './priceChanges.service';
export * from './priceChangesHeaders.service';
import { PriceChangesHeadersService } from './priceChangesHeaders.service';
export * from './priceNames.service';
import { PriceNamesService } from './priceNames.service';
export * from './prices.service';
import { PricesService } from './prices.service';
export * from './printGroups.service';
import { PrintGroupsService } from './printGroups.service';
export * from './productFuturePrices.service';
import { ProductFuturePricesService } from './productFuturePrices.service';
export * from './productGroupCategories.service';
import { ProductGroupCategoriesService } from './productGroupCategories.service';
export * from './productGroups.service';
import { ProductGroupsService } from './productGroups.service';
export * from './productPrices.service';
import { ProductPricesService } from './productPrices.service';
export * from './products.service';
import { ProductsService } from './products.service';
export * from './productsInLocations.service';
import { ProductsInLocationsService } from './productsInLocations.service';
export * from './purchaseOrderDetails.service';
import { PurchaseOrderDetailsService } from './purchaseOrderDetails.service';
export * from './purchaseOrderHeaders.service';
import { PurchaseOrderHeadersService } from './purchaseOrderHeaders.service';
export * from './ranges.service';
import { RangesService } from './ranges.service';
export * from './recipeIngredients.service';
import { RecipeIngredientsService } from './recipeIngredients.service';
export * from './recipeMethods.service';
import { RecipeMethodsService } from './recipeMethods.service';
export * from './reportFavourites.service';
import { ReportFavouritesService } from './reportFavourites.service';
export * from './reportFilterSettings.service';
import { ReportFilterSettingsService } from './reportFilterSettings.service';
export * from './reportGroups.service';
import { ReportGroupsService } from './reportGroups.service';
export * from './reportTemplateColumnSettings.service';
import { ReportTemplateColumnSettingsService } from './reportTemplateColumnSettings.service';
export * from './reportTemplateFilterValues.service';
import { ReportTemplateFilterValuesService } from './reportTemplateFilterValues.service';
export * from './reportTemplates.service';
import { ReportTemplatesService } from './reportTemplates.service';
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './revenueGroups.service';
import { RevenueGroupsService } from './revenueGroups.service';
export * from './salesSpecialProductsInLocation.service';
import { SalesSpecialProductsInLocationService } from './salesSpecialProductsInLocation.service';
export * from './salesSpecials.service';
import { SalesSpecialsService } from './salesSpecials.service';
export * from './salesStock.service';
import { SalesStockService } from './salesStock.service';
export * from './stock.service';
import { StockService } from './stock.service';
export * from './stockAdjustments.service';
import { StockAdjustmentsService } from './stockAdjustments.service';
export * from './stockAuditTrail.service';
import { StockAuditTrailService } from './stockAuditTrail.service';
export * from './stockAuditTrailTransactionTypes.service';
import { StockAuditTrailTransactionTypesService } from './stockAuditTrailTransactionTypes.service';
export * from './stockCategories.service';
import { StockCategoriesService } from './stockCategories.service';
export * from './stockCreationTemplateFactors.service';
import { StockCreationTemplateFactorsService } from './stockCreationTemplateFactors.service';
export * from './stockCreationTemplates.service';
import { StockCreationTemplatesService } from './stockCreationTemplates.service';
export * from './stockDietaryInformation.service';
import { StockDietaryInformationService } from './stockDietaryInformation.service';
export * from './stockDiscrepancyDetails.service';
import { StockDiscrepancyDetailsService } from './stockDiscrepancyDetails.service';
export * from './stockDiscrepancyHeaders.service';
import { StockDiscrepancyHeadersService } from './stockDiscrepancyHeaders.service';
export * from './stockExtendedDetails.service';
import { StockExtendedDetailsService } from './stockExtendedDetails.service';
export * from './stockGroups.service';
import { StockGroupsService } from './stockGroups.service';
export * from './stockInLocationPeriodDetailsDay.service';
import { StockInLocationPeriodDetailsDayService } from './stockInLocationPeriodDetailsDay.service';
export * from './stockInLocationPeriodDetailsMonth.service';
import { StockInLocationPeriodDetailsMonthService } from './stockInLocationPeriodDetailsMonth.service';
export * from './stockInLocationPeriodDetailsWeek.service';
import { StockInLocationPeriodDetailsWeekService } from './stockInLocationPeriodDetailsWeek.service';
export * from './stockInLocationPeriodDetailsYear.service';
import { StockInLocationPeriodDetailsYearService } from './stockInLocationPeriodDetailsYear.service';
export * from './stockInLocations.service';
import { StockInLocationsService } from './stockInLocations.service';
export * from './stockReceiveDetailsBonusAffectedItems.service';
import { StockReceiveDetailsBonusAffectedItemsService } from './stockReceiveDetailsBonusAffectedItems.service';
export * from './stockReceivedDetails.service';
import { StockReceivedDetailsService } from './stockReceivedDetails.service';
export * from './stockReceivedHeaders.service';
import { StockReceivedHeadersService } from './stockReceivedHeaders.service';
export * from './stockStatuses.service';
import { StockStatusesService } from './stockStatuses.service';
export * from './stockTransferDetails.service';
import { StockTransferDetailsService } from './stockTransferDetails.service';
export * from './stockTransferHeaders.service';
import { StockTransferHeadersService } from './stockTransferHeaders.service';
export * from './stocktakeGroups.service';
import { StocktakeGroupsService } from './stocktakeGroups.service';
export * from './stocktakeItems.service';
import { StocktakeItemsService } from './stocktakeItems.service';
export * from './stocktakeItemsDataEntry.service';
import { StocktakeItemsDataEntryService } from './stocktakeItemsDataEntry.service';
export * from './stocktakes.service';
import { StocktakesService } from './stocktakes.service';
export * from './supplierInventoryCodes.service';
import { SupplierInventoryCodesService } from './supplierInventoryCodes.service';
export * from './supplierTypes.service';
import { SupplierTypesService } from './supplierTypes.service';
export * from './supplierVenueSettings.service';
import { SupplierVenueSettingsService } from './supplierVenueSettings.service';
export * from './suppliers.service';
import { SuppliersService } from './suppliers.service';
export * from './taxNames.service';
import { TaxNamesService } from './taxNames.service';
export * from './taxRates.service';
import { TaxRatesService } from './taxRates.service';
export * from './templateRangeToStockInLocationTypes.service';
import { TemplateRangeToStockInLocationTypesService } from './templateRangeToStockInLocationTypes.service';
export * from './templateRangeToStockInLocations.service';
import { TemplateRangeToStockInLocationsService } from './templateRangeToStockInLocations.service';
export * from './varieties.service';
import { VarietiesService } from './varieties.service';
export * from './venueDetails.service';
import { VenueDetailsService } from './venueDetails.service';
export * from './venueLocations.service';
import { VenueLocationsService } from './venueLocations.service';
export * from './venueSettings.service';
import { VenueSettingsService } from './venueSettings.service';
export * from './venues.service';
import { VenuesService } from './venues.service';
export * from './zones.service';
import { ZonesService } from './zones.service';
export const APIS = [AuditLogsService, BarcodesService, ContainersService, CookingDepartmentsService, CountriesService, DefaultSettingsService, DietaryInformationService, ExpenseGroupsService, FactorNotesService, FactorsService, FuturePricesService, IntegrationService, LocationSegmentsService, LocationTypesService, MixAndMatchLocationsService, MixAndMatchPromotionsService, MixAndMatchPurchaseRequirementSetProductGroupsService, MixAndMatchPurchaseRequirementSetProductsService, MixAndMatchPurchaseRequirementsService, OfferLocationTypesService, OfferLocationsService, OfferRuleProductGroupsService, OfferRuleProductRangesService, OfferRuleProductsService, OfferRulesService, OfferVenuesService, OffersService, OrganisationSettingsService, OrganisationsService, PackageItemSubstituteProductGroupsService, PackageItemSubstitutesService, PackageItemsService, PriceChangesService, PriceChangesHeadersService, PriceNamesService, PricesService, PrintGroupsService, ProductFuturePricesService, ProductGroupCategoriesService, ProductGroupsService, ProductPricesService, ProductsService, ProductsInLocationsService, PurchaseOrderDetailsService, PurchaseOrderHeadersService, RangesService, RecipeIngredientsService, RecipeMethodsService, ReportFavouritesService, ReportFilterSettingsService, ReportGroupsService, ReportTemplateColumnSettingsService, ReportTemplateFilterValuesService, ReportTemplatesService, ReportsService, RevenueGroupsService, SalesSpecialProductsInLocationService, SalesSpecialsService, SalesStockService, StockService, StockAdjustmentsService, StockAuditTrailService, StockAuditTrailTransactionTypesService, StockCategoriesService, StockCreationTemplateFactorsService, StockCreationTemplatesService, StockDietaryInformationService, StockDiscrepancyDetailsService, StockDiscrepancyHeadersService, StockExtendedDetailsService, StockGroupsService, StockInLocationPeriodDetailsDayService, StockInLocationPeriodDetailsMonthService, StockInLocationPeriodDetailsWeekService, StockInLocationPeriodDetailsYearService, StockInLocationsService, StockReceiveDetailsBonusAffectedItemsService, StockReceivedDetailsService, StockReceivedHeadersService, StockStatusesService, StockTransferDetailsService, StockTransferHeadersService, StocktakeGroupsService, StocktakeItemsService, StocktakeItemsDataEntryService, StocktakesService, SupplierInventoryCodesService, SupplierTypesService, SupplierVenueSettingsService, SuppliersService, TaxNamesService, TaxRatesService, TemplateRangeToStockInLocationTypesService, TemplateRangeToStockInLocationsService, VarietiesService, VenueDetailsService, VenueLocationsService, VenueSettingsService, VenuesService, ZonesService];
